//* Variables Imports
import { URL } from "../../../variables";

function DocumentosPanel({ inscricao }) {
  const docs = (inscricao.documentos || []).filter(
    (doc) => doc.tipoDocumento !== "laudo_medico"
  );

  return (
    <>
      <h5 style={{ color: "black", marginTop: 10, marginBottom: 10 }}>
        Documentos
      </h5>
      <div className="table-rep-plugin">
        <div className="table-responsive mb-0" data-pattern="priority-columns">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Arquivo</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {docs.map((doc) => (
                <tr key={doc.id}>
                  <td style={{ textTransform: "capitalize" }}>
                    {(doc.tipoDocumento || "").replace(/_/g, " ")}
                  </td>
                  <td>{doc.arquivoNomeOriginal || "-"}</td>
                  <td>
                    {doc.arquivoCaminho ? (
                      <a
                        href={`${doc.arquivoCaminho}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-primary"
                        style={{ color: "white" }}
                      >
                        Ver Documento
                      </a>
                    ) : (
                      <span>-</span>
                    )}
                  </td>
                </tr>
              ))}
              {docs.length === 0 && (
                <tr>
                  <td colSpan="3">
                    Nenhum documento anexado (exceto laudo médico)
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default DocumentosPanel;